// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__SN+MX","errorCode":"NotFound_errorCode__d+CGc"};